export const script = (url: string, cb?: () => void) => {
  const element = document.createElement("script");
  element.onload = () => cb?.();
  element.src = url;
  element.async = true;
  document.head.appendChild(element);
};
